/// <amd-module name="Artifacts/Nuget/commands/Delete" />
import { NugetActions } from "Artifacts/Nuget/redux";
import { getDeleteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createDeleteCommand = getDeleteCommandCreator(NugetActions.softDelete);
